// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"nav-link-two-container_wrapper__3wtXb"};